import React from "react";

import svg from "../../assets/images/icons/plus_blue.svg";

export const PlusBlueIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Plus"}
    />
);
